/* ============================================================
   Podcast My ženy – chování stránek podcastu
   ------------------------------------------------------------
   Řeší čtyři věci:
   1) facade přehrávače  – iframe se načte až po kliknutí
   2) popup „Poslouchat" – výběr platformy pro konkrétní díl
   3) deep linky         – otevření aplikace místo webu tam,
                           kde to prohlížeč zvládne
   4) kapitoly + kopírování slevového kódu

   Vše přes delegaci na document, aby to přežilo Section
   Rendering API i editor motivu. Skript je idempotentní –
   načte-li se dvakrát (sekce si ho přidávají samy), druhý
   běh se hned ukončí.

   Save as: assets/zenzena-podcast.js
   ============================================================ */

(function () {
  if (window.__zzPodcast) return;
  window.__zzPodcast = true;

  /* ---------------------------------------------------------
     In-app prohlížeče Instagramu a Facebooku často nectí
     universal links – klik na https://open.spotify.com/…
     zůstane uvnitř webview místo otevření aplikace. A právě
     odtud chodí většina mobilní návštěvnosti. Jen tam tedy
     sáhneme po custom scheme. Nikde jinde: na moderním
     iOS/Androidu dělá zbytečné chybové dialogy.
  --------------------------------------------------------- */
  var UA = navigator.userAgent || '';
  var IS_IN_APP = /Instagram|FBAN|FBAV|FB_IAB|TikTok|Line\//i.test(UA);
  var IS_MOBILE = /Android|iPhone|iPad|iPod/i.test(UA);

  var STORE_KEY = 'zenzena:podcast:platform';

  function remember(platform) {
    try {
      localStorage.setItem(STORE_KEY, platform);
    } catch (e) {
      /* private mode – preference si prostě nezapamatujeme */
    }
  }

  function preferred() {
    try {
      return localStorage.getItem(STORE_KEY);
    } catch (e) {
      return null;
    }
  }

  function track(platform, title) {
    var payload = {
      platform: platform,
      episode: title || document.title
    };
    if (typeof window.gtag === 'function') {
      window.gtag('event', 'podcast_platform_click', payload);
    }
    if (Array.isArray(window.dataLayer)) {
      window.dataLayer.push(
        Object.assign({ event: 'podcast_platform_click' }, payload)
      );
    }
  }

  /* Vrátí adresu, na kterou se má reálně navigovat. */
  function resolveHref(platform, href, id) {
    if (IS_IN_APP && IS_MOBILE && platform === 'spotify' && id) {
      return 'spotify://episode/' + id;
    }
    return href;
  }

  /* ---------------------------------------------------------
     1) Facade přehrávače
  --------------------------------------------------------- */
  function loadPlayer(facade) {
    var wrap = facade.closest('.zzp-player');
    if (!wrap) return;

    var src = facade.getAttribute('data-embed');
    if (!src) return;

    var height = facade.getAttribute('data-height') || '352';
    var iframe = document.createElement('iframe');

    iframe.className = 'zzp-player__frame';
    iframe.src = src;
    iframe.height = height;
    iframe.setAttribute('loading', 'lazy');
    iframe.setAttribute('title', facade.getAttribute('data-title') || 'Přehrávač epizody');
    iframe.setAttribute('allowfullscreen', '');
    iframe.setAttribute(
      'allow',
      'autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture'
    );

    wrap.replaceChildren(iframe);
    wrap.setAttribute('data-zzp-loaded', '1');
  }

  /* ---------------------------------------------------------
     2) Popup „Poslouchat"

     Modal SE TADY NEVYRÁBÍ. <x-modal> vytvořený přes
     document.createElement se neupgraduje na komponentu motivu –
     zůstane z něj HTMLUnknownElement bez shadow DOM i bez
     metody show(). Musí přijít ze serveru, což dělá
     snippets/zenzena-podcast-listen-modal.liquid (jeden na sekci).

     Otevírání taky neřešíme: tlačítko má aria-controls s id
     modalu, a to je pro DialogElement motivu aktivátor. Focus
     trap, zamčení scrollu, Escape i klik mimo tím máme zdarma.
     Zbývá jediné – před otevřením doplnit název dílu a odkazy.
  --------------------------------------------------------- */

  var ICONS = {
    spotify:
      '<svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20Zm4.586 14.424a.623.623 0 0 1-.857.207c-2.348-1.435-5.304-1.76-8.785-.964a.623.623 0 1 1-.277-1.215c3.809-.87 7.077-.496 9.713 1.115a.623.623 0 0 1 .206.857Zm1.223-2.722a.78.78 0 0 1-1.072.257c-2.688-1.652-6.786-2.131-9.965-1.166a.78.78 0 1 1-.452-1.492c3.63-1.102 8.145-.568 11.232 1.329a.78.78 0 0 1 .257 1.072Zm.105-2.835c-3.223-1.914-8.54-2.09-11.617-1.156a.935.935 0 1 1-.542-1.79c3.532-1.072 9.404-.865 13.115 1.338a.935.935 0 0 1-.956 1.608Z"/></svg>',
    youtube:
      '<svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M23.5 6.2a3 3 0 0 0-2.1-2.1C19.5 3.6 12 3.6 12 3.6s-7.5 0-9.4.5A3 3 0 0 0 .5 6.2 31.3 31.3 0 0 0 0 12a31.3 31.3 0 0 0 .5 5.8 3 3 0 0 0 2.1 2.1c1.9.5 9.4.5 9.4.5s7.5 0 9.4-.5a3 3 0 0 0 2.1-2.1A31.3 31.3 0 0 0 24 12a31.3 31.3 0 0 0-.5-5.8ZM9.6 15.6V8.4l6.2 3.6-6.2 3.6Z"/></svg>',
    apple:
      '<svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12 1.5a8.4 8.4 0 0 0-8.4 8.4c0 3.2 1.8 6 4.4 7.4a.6.6 0 0 0 .9-.6l-.2-1a.7.7 0 0 0-.34-.47A6.9 6.9 0 0 1 5.1 9.9 6.9 6.9 0 0 1 12 3a6.9 6.9 0 0 1 6.9 6.9 6.9 6.9 0 0 1-3.26 5.86.7.7 0 0 0-.33.47l-.2 1a.6.6 0 0 0 .89.6 8.4 8.4 0 0 0 4.4-7.4A8.4 8.4 0 0 0 12 1.5Zm0 4.2a4.2 4.2 0 0 0-2.2 7.78.6.6 0 0 0 .9-.63l-.18-.94a.7.7 0 0 0-.28-.43A2.7 2.7 0 1 1 14.46 9a2.7 2.7 0 0 1-1.2 2.24.7.7 0 0 0-.29.43l-.18.94a.6.6 0 0 0 .9.63A4.2 4.2 0 0 0 12 5.7Zm0 5.1a1.65 1.65 0 0 0-1.63 1.93l.83 4.8a.81.81 0 0 0 1.6 0l.83-4.8A1.65 1.65 0 0 0 12 10.8Z"/></svg>'
  };

  var LABELS = {
    spotify: 'Spotify',
    youtube: 'YouTube',
    apple: 'Apple Podcasts'
  };

  function fillListenModal(button) {
    var id = button.getAttribute('aria-controls');
    var modalEl = id ? document.getElementById(id) : null;
    if (!modalEl) return;

    var title = button.getAttribute('data-title') || '';
    var titleEl = modalEl.querySelector('[data-zzp-modal-title]');
    var listEl = modalEl.querySelector('[data-zzp-modal-list]');
    if (titleEl) titleEl.textContent = title;
    if (!listEl) return;

    var order = ['spotify', 'youtube', 'apple'];
    var fav = preferred();
    if (fav && order.indexOf(fav) > 0) {
      order.splice(order.indexOf(fav), 1);
      order.unshift(fav);
    }

    listEl.replaceChildren();

    order.forEach(function (platform) {
      var href = button.getAttribute('data-' + platform);
      if (!href) return;

      var a = document.createElement('a');
      a.className = 'zzp-platform';
      a.href = href;
      a.target = '_blank';
      a.rel = 'noopener';
      a.setAttribute('data-zzp-platform', platform);
      a.setAttribute('data-title', title);
      if (platform === 'spotify') {
        var sid = button.getAttribute('data-spotify-id');
        if (sid) a.setAttribute('data-platform-id', sid);
      }
      a.innerHTML = (ICONS[platform] || '') + '<span>' + LABELS[platform] + '</span>';
      listEl.appendChild(a);
    });
  }

  /* ---------------------------------------------------------
     4) Kapitoly – přetočení běžícího přehrávače
  --------------------------------------------------------- */
  function seek(button) {
    var seconds = parseInt(button.getAttribute('data-seconds'), 10);
    if (isNaN(seconds)) return;

    var scope = button.closest('[data-zzp-scope]') || document;
    var wrap = scope.querySelector('.zzp-player');
    if (!wrap) return;

    var facade = wrap.querySelector('.zzp-facade');
    var base = facade
      ? facade.getAttribute('data-embed')
      : wrap.getAttribute('data-embed-base');
    if (!base) {
      var existing = wrap.querySelector('iframe');
      base = existing ? existing.src.split(/[?&](?:t|start)=/)[0] : null;
    }
    if (!base) return;

    var joiner = base.indexOf('?') === -1 ? '?' : '&';
    var param = base.indexOf('youtube') !== -1 ? 'start=' : 't=';
    var src = base + joiner + param + seconds + (base.indexOf('youtube') !== -1 ? '&autoplay=1' : '');

    var iframe = wrap.querySelector('iframe');
    if (!iframe) {
      if (facade) {
        facade.setAttribute('data-embed', src);
        loadPlayer(facade);
      }
      return;
    }
    iframe.src = src;
    wrap.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  /* ---------------------------------------------------------
     Kopírování slevového kódu
  --------------------------------------------------------- */
  function copyCode(button) {
    var code = button.getAttribute('data-code');
    if (!code) return;

    var done = function () {
      var label = button.querySelector('[data-zzp-code-label]');
      if (!label) return;
      var original = label.textContent;
      label.textContent = 'Zkopírováno';
      setTimeout(function () {
        label.textContent = original;
      }, 1800);
    };

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code).then(done, function () {});
    }
  }

  /* ---------------------------------------------------------
     Sdílení – „Kopírovat odkaz" jako první volba, protože
     v Česku se sdílí do WhatsAppu a Messengeru, ne na zeď.
  --------------------------------------------------------- */
  function copyLink(button) {
    var url = button.getAttribute('data-url') || location.href;
    var done = function () {
      var label = button.querySelector('[data-zzp-share-label]');
      if (!label) return;
      var original = label.textContent;
      label.textContent = 'Odkaz zkopírován';
      setTimeout(function () {
        label.textContent = original;
      }, 1800);
    };

    if (navigator.share && IS_MOBILE) {
      navigator
        .share({ title: button.getAttribute('data-title') || document.title, url: url })
        .catch(function () {});
      return;
    }
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(url).then(done, function () {});
    }
  }

  /* ---------------------------------------------------------
     Rail – šipky
  --------------------------------------------------------- */
  function scrollRail(button) {
    var scope = button.closest('[data-zzp-scope]');
    if (!scope) return;
    var rail = scope.querySelector('.zzp-rail');
    if (!rail) return;

    var first = rail.firstElementChild;
    var step = first ? first.getBoundingClientRect().width + 16 : rail.clientWidth * 0.8;
    rail.scrollBy({
      left: button.getAttribute('data-dir') === 'prev' ? -step : step,
      behavior: 'smooth'
    });
  }

  function syncArrows(rail) {
    var scope = rail.closest('[data-zzp-scope]');
    if (!scope) return;
    var prev = scope.querySelector('[data-zzp-rail][data-dir="prev"]');
    var next = scope.querySelector('[data-zzp-rail][data-dir="next"]');
    var max = rail.scrollWidth - rail.clientWidth - 2;
    if (prev) prev.disabled = rail.scrollLeft <= 2;
    if (next) next.disabled = rail.scrollLeft >= max;
  }

  /* ---------------------------------------------------------
     Delegace
  --------------------------------------------------------- */
  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;

    var facade = target.closest('.zzp-facade');
    if (facade) {
      event.preventDefault();
      loadPlayer(facade);
      return;
    }

    var listen = target.closest('[data-zzp-listen]');
    if (listen) {
      /*
        Žádné preventDefault: otevření modalu obstará
        DialogElement motivu přes aria-controls. My jen
        stihneme doplnit obsah dřív, než se ukáže.
      */
      fillListenModal(listen);
      return;
    }

    var platform = target.closest('[data-zzp-platform]');
    if (platform) {
      var name = platform.getAttribute('data-zzp-platform');
      remember(name);
      track(name, platform.getAttribute('data-title'));

      var resolved = resolveHref(
        name,
        platform.getAttribute('href'),
        platform.getAttribute('data-platform-id')
      );
      if (resolved !== platform.getAttribute('href')) {
        event.preventDefault();
        window.location.href = resolved;
      }
      return;
    }

    var chapter = target.closest('[data-zzp-seek]');
    if (chapter) {
      event.preventDefault();
      seek(chapter);
      return;
    }

    var code = target.closest('[data-zzp-code]');
    if (code) {
      event.preventDefault();
      copyCode(code);
      return;
    }

    var share = target.closest('[data-zzp-share]');
    if (share) {
      event.preventDefault();
      copyLink(share);
      return;
    }

    var arrow = target.closest('[data-zzp-rail]');
    if (arrow) {
      event.preventDefault();
      scrollRail(arrow);
    }
  });

  function initRails(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('.zzp-rail').forEach(function (rail) {
      if (rail.dataset.zzpRailInit) return;
      rail.dataset.zzpRailInit = '1';
      syncArrows(rail);
      rail.addEventListener(
        'scroll',
        function () {
          syncArrows(rail);
        },
        { passive: true }
      );
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initRails();
    });
  } else {
    initRails();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initRails(event.target);
  });
})();
